import htmlcomponent from 'htmlcomponent'
import events from "eventslibjs";

export default function overlay(dom, opts) {
	const options = {
		openTrigger: "[data-overlay-open]",
		closeTrigger: "[data-overlay-close]",
		openCls: "display",
		bodyCls: "shadow",
		overlaySel: "overlay__content",
		...opts
	}

	init()

	function init() {
		events.on('click', options.openTrigger, onOpen)
		events.on('click', options.closeTrigger, onClose)
		
		function onOpen() {
			dom.classList.add(options.openCls)
			document.body.classList.add(options.bodyCls)
		}		
		
		function onClose() {
			dom.classList.remove(options.openCls)
			document.body.classList.remove(options.bodyCls)
		}
		
		function getOverlay() {
			return dom.querySelector(options.overlaySel)
		}

		//htmlcomponent.dispatch()
	}

}